import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './PdfViewer.module.css';

const PdfViewer = ({ fileUrl }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: defaultTabs => [],
  });

  const isPdf = fileUrl?.toLowerCase()?.endsWith('.pdf');

  return (
    <div className="w-full h-[500px] md:h-[769px]">
      {isPdf ? (
        <Worker workerUrl="/scripts/pdf.worker.js">
          <Viewer fileUrl={fileUrl} plugins={[defaultLayoutPluginInstance]} />
        </Worker>
      ) : (
        <iframe
          src={fileUrl}
          title="Document Viewer"
          width="100%"
          height="100%"
          className="border-0"
        />
      )}
    </div>
  );
};

export default PdfViewer;
